module.exports = __webpack_public_path__ + "img/12_72.61d31e78.png";